export const OVER_TIME = {
    allFac: '40+ hours for IntelyCare',
    myFac: '40+ hours at my facility',
    No: 'Don\'t allow overtime'
};
